import { createOruga, Modal } from '@oruga-ui/oruga-next'
import type { OrugaConfig } from '@oruga-ui/oruga-next'
import { bulmaConfig } from '@oruga-ui/theme-bulma'

export default defineNuxtPlugin((nuxtApp) => {
  const config: OrugaConfig = {
    ...bulmaConfig,
  }

  const oruga = createOruga(config).use(Modal)
  nuxtApp.vueApp.use(oruga)
})
